"use strict";

exports.__esModule = true;
exports.getDeviceDataItems = getDeviceDataItems;
/**
 * A device's `dataItems` are an API enrichment rather than part of the device: the plant
 * service returns them only when the device is fetched with `?withDataItems=true`, and
 * `IDevice` in @vimana/vimana-types does not declare the field at all. Most DeviceContext
 * providers supply devices without it, so `device.dataItems` is undefined for a large share
 * of callers and dereferencing it throws.
 *
 * Read data items through here rather than off the device.
 */
function getDeviceDataItems(device) {
  var _device$dataItems;
  return (_device$dataItems = device == null ? void 0 : device.dataItems) != null ? _device$dataItems : [];
}